export type RequestErrorBody = {
  error?: string;
  errors?: Array<{
    code?: string;
    path?: string[];
    message?: string;
    error?: string;
  }>;
};

export class RequestError extends Error {
  status: number;
  code?: number;
  /** Parsed JSON response body when available (e.g. contains `errors` array) */
  body?: RequestErrorBody;
  constructor(
    message: string,
    status: number,
    code?: number,
    body?: RequestErrorBody,
  ) {
    super(message);
    this.name = "RequestError";
    this.status = status;
    this.code = code;
    this.body = body;
  }
}
